import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'

import happyman from '../src/happy-man.jpg'
import swishlogo from '../src/swish-logo.png'
import rolexbox from '../src/rolex-box.png'
import daytona from '../src/daytona.jpg'
import truck from '../src/postnord-truck.png'
import qualityteam from '../src/quality-team.jpg'
import urbrev from '../src/urbrev-logo.png'

const navigation = [
  { name: 'Kronos köpskydd', href: '/kronos-secure' },
  { name: 'Kronos Certified', href: '/kronos-certified' },
  { name: 'Kontrollera certifiering', href: '/kronos-certified-control' },
  { name: 'Klockvärdering', href: '/klockvardering' },
  { name: 'Företagsannonsering', href: '/foretagsannonsering' },
  { name: 'Marknadsföring', href: '/marknadsforing' },
  { name: 'Blogg', href: '/blogg' },
  { name: 'Integritetspolicy', href: '/integritetspolicy' },
  { name: 'Användarvillkor', href: '/anvandarvillkor' },
]

const steps = [
  {
    number: '01',
    title: 'Köparen betalar',
    text: 'Köparen genomför betalningen med Swish via Kronos.',
  },
  {
    number: '02',
    title: 'Klockan skickas med PostNord',
    text: 'Säljaren skickar klockan med spårbar frakt via PostNord direkt genom Kronos.',
  },
  {
    number: '03',
    title: 'Betalningen hålls under affären',
    text: 'UrBrev hanterar pengarna medan leveransen genomförs enligt tjänstens villkor.',
  },
  {
    number: '04',
    title: 'Köparen kontrollerar klockan',
    text: 'Köparen tar emot klockan och får möjlighet att kontrollera den inom 24 timmar.',
  },
  {
    number: '05',
    title: 'Utbetalning till säljaren',
    text: 'När affären är slutförd betalas pengarna ut enligt villkoren för Kronos Secure.',
  },
]

const faqs = [
  {
    question: 'Vad är Kronos Secure?',
    answer:
      'Kronos Secure är Kronos köpskydd för klockaffärer. Tjänsten samlar betalning och frakt i köpet och är framtagen för att göra affären tryggare för både köpare och säljare.',
  },
  {
    question: 'Kan jag köpa och sälja klockor med frakt via PostNord?',
    answer:
      'Ja. Med Kronos Secure kan klockor skickas med spårbar frakt via PostNord direkt genom Kronos. Följ instruktionerna som visas för den aktuella affären.',
  },
  {
    question: 'Hur betalar jag för en klocka?',
    answer:
      'Köparen betalar med Swish via Kronos. Betalningen hanteras enligt upplägget för Kronos Secure och villkoren för tjänsten.',
  },
  {
    question: 'Kostar Kronos Secure något för säljaren?',
    answer:
      'Enligt upplägget som beskrivs här är tjänsten kostnadsfri för säljaren. Köparen står för kostnaden. Kontrollera alltid det aktuella priset och villkoren innan du genomför köpet.',
  },
  {
    question: 'Hur lång tid har köparen på sig att kontrollera klockan?',
    answer:
      'Köparen har enligt den beskrivna tjänsten 24 timmar på sig att kontrollera klockan efter mottagandet. Läs de aktuella villkoren för att se exakt hur tidsfristen och utbetalningen fungerar.',
  },
]

const sellerCards = [
  {
    title: 'Sälj din klocka med Swish',
    text: 'Med Kronos Secure får din annons en köpknapp. Köparen betalar enkelt med Swish, vilket gör köpet smidigare för båda parter.',
    extra: 'Det är gratis att lägga till Kronos Secure på din befintliga eller nya annons.',
    image: swishlogo,
    alt: 'Swish betalning',
    imageContain: true,
  },
  {
    title: 'Gör din annons mer attraktiv',
    text: 'Erbjud potentiella köpare ett tryggare sätt att genomföra affären och gör det enklare för dem att ta nästa steg.',
    image: happyman,
    alt: 'Nöjd kund',
  },
  {
    title: 'Smidig frakt med PostNord',
    text: 'Sälj och skicka klockan med PostNord direkt via Kronos. Vid en försäljning får du en färdig fraktsedel via e-post eller SMS. Packa klockan och lämna in försändelsen hos ett PostNord-ombud.',
    extra: 'Alltid spårbar leverans från inlämning till leverans.',
    image: truck,
    alt: 'PostNord leverans',
  },
  {
    title: 'Gratis för säljaren',
    text: 'Som säljare kan du använda Kronos Secure utan kostnad. Kostnaden täcks av köparen. Lägg till extra trygghet i din annons och nå fler seriösa köpare.',
    image: rolexbox,
    alt: 'Klockförpackning',
  },
  {
    title: 'Ett team som granskar annonser',
    text: 'Vårt team granskar annonser och arbetar för att identifiera misstänkt aktivitet. Målet är att skapa en tryggare plattform för både köpare och säljare.',
    image: qualityteam,
    alt: 'Kronos kvalitetsteam',
  },
]

const buyerCards = [
  {
    title: 'Köp din klocka med Swish',
    text: 'Med Kronos Secure kan du köpa din nästa klocka direkt med Swish och samla betalning och affär på samma plats.',
    image: swishlogo,
    alt: 'Swish betalning',
    imageContain: true,
  },
  {
    title: 'Betalning med depositionstjänst',
    text: 'Köpesumman placeras på ett klientmedelskonto tills affären är klar. Som köpare har du 24 timmar på dig att kontrollera klockan. Om vi inte hör något från dig inom den tiden betalas pengarna ut till säljaren när tiden har passerat.',
    image: happyman,
    alt: 'Trygg klockaffär',
  },
  {
    title: 'Bevisat ägarskap',
    text: 'Privata annonser kontrolleras innan publicering. Säljaren behöver skicka in två unika bilder där klockan är inställd på specifika tider, för att styrka att personen har tillgång till klockan.',
    image: daytona,
    alt: 'Lyxklocka',
  },
  {
    title: 'Alltid spårbara försändelser',
    text: 'Köp klockor och få dem skickade med PostNord direkt via Kronos. Alla försändelser med Kronos Secure är spårbara, så att du kan följa klockan från inlämning till leverans.',
    image: truck,
    alt: 'PostNord leverans',
  },
  {
    title: 'Vi arbetar för tryggare handel',
    text: 'Vårt team granskar annonser och identifierar misstänkt aktivitet för att skapa en tryggare plattform, så att du kan fokusera på att hitta din nästa drömklocka.',
    image: qualityteam,
    alt: 'Kronos kvalitetsteam',
  },
]

function FeatureCard({ item, index }) {
  const imageFirst = index % 2 === 1
  return (
    <article
      className={`group grid overflow-hidden rounded-3xl border border-slate-200/80 bg-white shadow-[0_12px_40px_-28px_rgba(15,23,42,0.28)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_-32px_rgba(15,23,42,0.28)] md:grid-cols-2 ${imageFirst ? 'md:[&>div:first-child]:order-2' : ''}`}
    >
      <div className="flex min-h-[250px] items-center justify-center overflow-hidden bg-slate-50 p-7 sm:min-h-[310px] sm:p-10">
        <img
          src={item.image}
          alt={item.alt}
          className={`h-full max-h-[300px] w-full rounded-xl ${item.imageContain ? 'object-contain' : 'object-cover'}`}
        />
      </div>
      <div className="flex flex-col justify-center p-7 sm:p-10 lg:p-12">
        <div className="mb-5 flex h-10 w-10 items-center justify-center rounded-full bg-red-50 text-sm font-bold text-krono-red ring-1 ring-red-100">
          {String(index + 1).padStart(2, '0')}
        </div>
        <h3 className="font-poppins text-2xl font-semibold tracking-tight text-slate-950 sm:text-3xl">
          {item.title}
        </h3>
        <p className="mt-4 text-base leading-7 text-slate-600">{item.text}</p>
        {item.extra && (
          <p className="mt-3 text-sm font-semibold leading-6 text-slate-900">{item.extra}</p>
        )}
      </div>
    </article>
  )
}

function KronosSecure({ siteLogo }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [activeTab, setActiveTab] = useState('Säljare')
  const cards = activeTab === 'Säljare' ? sellerCards : buyerCards

  return (
    <div className="min-h-screen bg-white text-slate-900 antialiased">
      <header className="fixed inset-x-0 top-0 z-50 bg-white shadow">
        <nav className="flex items-center justify-between p-6 lg:px-8">
          <a href="/" className="flex items-center -m-1.5 p-1.5">
            <span className="sr-only">Krono</span>
            <img alt="Krono Logo" src={siteLogo} className="h-6 w-auto rounded-md" />
          </a>

          <div className="flex lg:hidden">
            <button
              type="button"
              className="p-2.5 text-gray-700 rounded-md"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open menu</span>
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </button>
          </div>

          <div className="hidden lg:flex lg:gap-x-8">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-sm font-semibold text-gray-900 hover:underline"
              >
                {item.name}
              </a>
            ))}
          </div>
        </nav>

        {/* Mobile menu */}
        <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
          <div className="fixed inset-0 z-50" />
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full max-w-sm bg-white px-6 py-6 overflow-y-auto shadow-lg">
            <div className="flex items-center justify-between">
              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="p-2.5 text-gray-700 rounded-md"
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 space-y-2">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                >
                  {item.name}
                </a>
              ))}
            </div>
          </DialogPanel>
        </Dialog>
      </header>

      <main>
        <section className="relative isolate overflow-hidden border-b border-slate-100 bg-[#fff] from-slate-100 via-white to-white">
          <div className="mx-auto max-w-7xl px-5 pb-20 pt-16 sm:px-8 sm:pb-24 sm:pt-24 lg:px-10 ">
            <div className="mx-auto max-w-4xl text-center">
              <div className="mb-7 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white/80 px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-slate-600 shadow-sm">
                <span className="h-2 w-2 rounded-full bg-krono-red" /> Tryggare klockaffärer online
              </div>
              <h1 className="font-poppins text-4xl font-semibold leading-[1.08] tracking-[-0.045em] text-slate-950 sm:text-6xl lg:text-7xl">
                Kronos Secure <span className="text-krono-red">köpskydd för klockor</span>
              </h1>
              <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-slate-600 sm:text-xl">
                Köp och sälj klockor tryggare med Kronos Secure. Betala med Swish och skicka klockan
                med spårbar frakt via PostNord direkt i Kronos.
              </p>
              <div className="mx-auto mt-7 flex max-w-3xl flex-wrap items-center justify-center gap-2">
                <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm">
                  <span className="text-krono-red" aria-hidden="true">
                    ✓
                  </span>{' '}
                  Frakt via PostNord
                </span>
                <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm">
                  <span className="text-krono-red" aria-hidden="true">
                    ✓
                  </span>{' '}
                  Alltid spårbar leverans
                </span>
                <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm">
                  <span className="text-krono-red" aria-hidden="true">
                    ✓
                  </span>{' '}
                  Betala med Swish
                </span>
              </div>
              <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <a
                  href="#how-it-works"
                  className="inline-flex min-h-12 items-center justify-center rounded-full bg-slate-950 px-7 py-3 text-sm font-semibold text-white shadow-lg shadow-slate-950/10 transition hover:-translate-y-0.5 hover:bg-slate-700"
                >
                  Upptäck hur det fungerar{' '}
                  <span className="ml-2" aria-hidden="true">
                    ↓
                  </span>
                </a>
                <a
                  href="#for-buyer-seller"
                  className="inline-flex min-h-12 items-center justify-center rounded-full border border-slate-200 bg-white px-7 py-3 text-sm font-semibold text-slate-700 transition hover:border-slate-400 hover:text-slate-950"
                >
                  För köpare och säljare
                </a>
                <a
                  href="#vanliga-fragor"
                  className="inline-flex min-h-12 items-center justify-center rounded-full px-5 py-3 text-sm font-semibold text-slate-600 transition hover:text-slate-950"
                >
                  Vanliga frågor
                </a>
              </div>
              <div className="mt-12 flex flex-col items-center justify-center gap-3 border-t border-slate-200/80 pt-7 sm:flex-row sm:gap-5">
                <span className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-600">
                  I samarbete med
                </span>
                <img
                  src={urbrev}
                  alt="UrBrev"
                  className="h-8 w-auto max-w-[150px] object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        <section
          aria-label="Köp och sälj med PostNord"
          className="border-y border-slate-200/80 bg-slate-50"
        >
          <div className="mx-auto grid max-w-7xl items-center gap-8 px-5 py-10 sm:px-8 md:grid-cols-[0.9fr_1.1fr] md:gap-12 md:py-14 lg:px-10">
            <div className="overflow-hidden rounded-3xl bg-white">
              <img
                src={truck}
                alt="PostNord leverans för klockaffärer via Kronos"
                className="h-56 w-full object-cover object-[15%_center] sm:h-72 md:h-80"
              />
            </div>
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-krono-red">
                Köp. Sälj. Skicka. Följ leveransen.
              </p>
              <h2 className="mt-4 font-poppins text-3xl font-semibold tracking-tight text-slate-950 sm:text-4xl">
                Nu kan du köpa och sälja med frakt via PostNord
              </h2>
              <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg">
                Genom Kronos Secure kan klockan skickas spårbart med PostNord. Du sköter affären
                direkt i Kronos och kan följa försändelsen hela vägen till mottagaren.
              </p>
              <a
                href="#for-buyer-seller"
                className="mt-7 inline-flex min-h-12 items-center justify-center rounded-full bg-slate-950 px-6 py-3 text-sm font-semibold text-white transition hover:bg-slate-700"
              >
                Läs mer för köpare och säljare{' '}
                <span className="ml-2" aria-hidden="true">
                  ↓
                </span>
              </a>
            </div>
          </div>
        </section>

        <section id="how-it-works" className="scroll-mt-24 py-20 sm:py-24 lg:py-28">
          <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
            <div className="mx-auto mb-12 max-w-2xl text-center sm:mb-16">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-krono-red">
                Fyra enkla steg
              </p>
              <h2 className="mt-4 font-poppins text-3xl font-semibold tracking-tight text-slate-950 sm:text-4xl">
                Så fungerar Kronos Secure köpskydd
              </h2>
              <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg">
                Följ stegen för att köpa eller sälja en klocka med Swish, köpskydd och frakt via
                PostNord.
              </p>
            </div>
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
              {steps.map((step) => (
                <article
                  key={step.number}
                  className="relative rounded-2xl border border-slate-200 bg-white p-6 sm:p-7"
                >
                  <p className="font-poppins text-4xl font-semibold tracking-tight text-slate-400">
                    {step.number}
                  </p>
                  <h3 className="mt-6 text-lg font-semibold text-slate-950">{step.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-slate-600">{step.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="for-buyer-seller" className="scroll-mt-24 bg-slate-50 py-20 sm:py-24 lg:py-28">
          <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
            <div className="mx-auto max-w-3xl text-center">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-krono-red">
                En tjänst för båda sidor
              </p>
              <h2 className="mt-4 font-poppins text-3xl font-semibold tracking-tight text-slate-950 sm:text-4xl">
                En bättre affär för alla
              </h2>
              <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg">
                Välj din roll för att läsa mer om hur Kronos Secure fungerar.
              </p>
            </div>
            <div
              className="mx-auto mt-9 flex w-fit rounded-full border border-slate-200 bg-white p-1.5 shadow-sm"
              role="tablist"
              aria-label="Välj köpare eller säljare"
            >
              {['Säljare', 'Köpare'].map((tab) => (
                <button
                  key={tab}
                  id={`tab-${tab}`}
                  role="tab"
                  aria-selected={activeTab === tab}
                  onClick={() => setActiveTab(tab)}
                  className={`min-w-28 rounded-full px-6 py-3 text-sm font-semibold transition duration-200 ${activeTab === tab ? 'bg-slate-950 text-white shadow-md' : 'text-slate-500 hover:text-slate-950'}`}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div
              className="mx-auto mt-10 max-w-5xl space-y-5 sm:mt-14 sm:space-y-7"
              role="tabpanel"
              aria-labelledby={`tab-${activeTab}`}
            >
              {cards.map((item, index) => (
                <FeatureCard key={`${activeTab}-${item.title}`} item={item} index={index} />
              ))}
            </div>
          </div>
        </section>

        <section
          id="vanliga-fragor"
          className="scroll-mt-24 border-t border-slate-200 bg-white py-20 sm:py-24 lg:py-28"
          aria-labelledby="faq-heading"
        >
          <div className="mx-auto max-w-4xl px-5 sm:px-8 lg:px-10">
            <div className="mx-auto max-w-2xl text-center">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-krono-red">
                Bra att veta
              </p>
              <h2
                id="faq-heading"
                className="mt-4 font-poppins text-3xl font-semibold tracking-tight text-slate-950 sm:text-4xl"
              >
                Vanliga frågor om Kronos Secure
              </h2>
              <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg">
                Här hittar du svar om köpskydd, betalning och frakt via PostNord när du köper eller
                säljer klockor på Kronos.
              </p>
            </div>
            <div className="mt-10 divide-y divide-slate-200 border-y border-slate-200">
              {faqs.map((faq) => (
                <details key={faq.question} className="group py-5">
                  <summary className="flex cursor-pointer list-none items-center justify-between gap-5 text-left text-base font-semibold text-slate-950 marker:content-none sm:text-lg">
                    <span>{faq.question}</span>
                    <span
                      aria-hidden="true"
                      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-slate-200 text-lg text-slate-600 transition group-open:rotate-45"
                    >
                      +
                    </span>
                  </summary>
                  <p className="max-w-3xl pr-10 pt-4 text-sm leading-7 text-slate-600 sm:text-base">
                    {faq.answer}
                  </p>
                </details>
              ))}
            </div>
            <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm">
              <a
                href="/kronos-certified"
                className="font-semibold text-slate-700 underline decoration-slate-300 underline-offset-4 hover:text-slate-950"
              >
                Läs om Kronos Certified
              </a>
              <a
                href="/kronos-certified-control"
                className="font-semibold text-slate-700 underline decoration-slate-300 underline-offset-4 hover:text-slate-950"
              >
                Kontrollera en certifiering
              </a>
              <a
                href="/anvandarvillkor"
                className="font-semibold text-slate-700 underline decoration-slate-300 underline-offset-4 hover:text-slate-950"
              >
                Läs användarvillkoren
              </a>
            </div>
          </div>
        </section>

        <section className="px-5 py-20 sm:px-8 sm:py-24 lg:px-10">
          <div className="mx-auto max-w-5xl overflow-hidden rounded-[2rem] bg-slate-950 px-7 py-12 text-center text-white sm:px-12 sm:py-16">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-red-300">
              Kronos Secure
            </p>
            <h2 className="mx-auto mt-4 max-w-2xl font-poppins text-3xl font-semibold tracking-tight sm:text-4xl">
              Fokusera på klockan. Vi hjälper till med tryggheten.
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base leading-7 text-slate-300">
              Har du frågor om Kronos Secure eller hur tjänsten fungerar? Vi hjälper dig gärna.
            </p>
            <a
              href="mailto:info@kronos.se"
              className="mt-8 inline-flex min-h-12 items-center justify-center rounded-full bg-white px-7 py-3 text-sm font-semibold text-slate-950 transition hover:bg-slate-200"
            >
              Kontakta oss{' '}
              <span className="ml-2" aria-hidden="true">
                ↗
              </span>
            </a>
          </div>
          <div className="mt-8 text-center text-sm text-slate-500">
            Du når oss även på{' '}
            <a
              href="mailto:info@kronos.se"
              className="font-semibold text-slate-800 underline decoration-slate-300 underline-offset-4 hover:decoration-slate-800"
            >
              info@kronos.se
            </a>
          </div>
        </section>
      </main>
    </div>
  )
}

export default KronosSecure
